import { render, staticRenderFns } from "./DeliveryForm.vue?vue&type=template&id=0e3e9d03&scoped=true"
import script from "./DeliveryForm.vue?vue&type=script&lang=ts"
export * from "./DeliveryForm.vue?vue&type=script&lang=ts"
import style0 from "./DeliveryForm.vue?vue&type=style&index=0&id=0e3e9d03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3e9d03",
  null
  
)

export default component.exports